export default "__VITE_PUBLIC_ASSET__abf8ceb4__"